import { RegionShared } from "@1games-ru/region-shared";
import { EstateLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { useCallback, useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import rpc from "@1games-ru/rage-rpc";
import EstateMpProvider from "@/core/data-provider/data-mp/estate/estate-mp-provider.ts";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import toast from "@/domains/toasts/helpers/toast.ts";

export default () => {
  const { t } = useTranslation("estate");
  const [show, setShow] = useState(false);
  const [estateId, setEstateId] = useState<number | null>(null);
  const [isLocked, setIsLocked] = useState<boolean>(false);
  const [level, setLevel] = useState<EstateLevel | null>(null);

  const loadEstate = useCallback(
    async (id: number): Promise<void> => {
      const response = await EstateMpProvider.getGuestInfo(id);
      if (response instanceof RpcMpProviderFailedResponse) {
        toast.error(t(`estate.error.${response.error.message}`));
        return;
      }

      setIsLocked(response.data.isLocked);
      setLevel(response.data.level);
    },
    [t],
  );

  const streetTransit = useCallback(async () => {
    const response = await EstateMpProvider.streetTransit(estateId);
    if (response instanceof RpcMpProviderFailedResponse) {
      toast.error(t(`estate.error.${response.error.message}`));
    }
  }, [t, estateId]);

  const updateLock = useCallback(
    async (newIsLocked: boolean) => {
      setIsLocked(newIsLocked);
      const response = await EstateMpProvider.lock(estateId, newIsLocked);
      if (response instanceof RpcMpProviderFailedResponse) {
        toast.error(t(`estate.error.${response.error.message}`));
        setIsLocked(!newIsLocked);
      }
    },
    [estateId, t],
  );

  useLayoutEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Estate.EstateIntercomShow,
      async (state: typeof RegionShared.Cef.Requests.EstateIntercomShowRequest): Promise<void> => {
        console.log("Estate intercom show", state);
        setShow(true);
        setEstateId(state.estateId);

        loadEstate(state.estateId);
      },
    );

    rpc.register(RegionShared.Cef.Events.Estate.EstateIntercomHide, async (): Promise<void> => {
      setShow(false);
      setEstateId(null);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateIntercomShow);
      rpc.unregister(RegionShared.Cef.Events.Estate.EstateIntercomHide);
    };
  }, [loadEstate]);

  return {
    show,
    level,
    isLocked,
    streetTransit,
    updateLock,
  };
};
